import React, { useContext } from 'react';
import { Row, Col, Typography } from 'antd';

import { version } from '../../../package.json';
import { ThemeContext } from '../Context/ThemeContext';

const { Text } = Typography;

export default function ProfileDrawerFooter(props) {
  const { theme } = useContext(ThemeContext);
  const getYear = () => {
    return new Date().getFullYear();
  };

  return (
    <div>
      <Row
        style={{
          textAlign: 'center',
          background: theme.content.bg,
          color: theme.drawer.text,
        }}
      >
        <Col span='24'>
          <Text
            style={{
              color: theme.drawer.text,
            }}
          >
            &copy; {getYear()}&nbsp;
            <a
              href='https://rajchandra.me/r/TcEskS30b?s=app_footer&m=live_app'
              rel='noopener noreferrer'
              target='_blank'
            >
              Raj Chandra
            </a>
            <br />
            <Text
              style={{ color: theme.drawer.secondaryText }}
              type='secondary'
            >
              For support contact
            </Text>{' '}
            <br />
            <a href='mailto:mail@rajchandra.me'>
              <Text
                style={{ color: theme.drawer.secondaryText }}
                type='secondary'
              >
                mail@rajchandra.me
              </Text>
            </a>
            <br />
            <Text
              style={{ color: theme.drawer.secondaryText }}
              type='secondary'
            >
              v{version}
            </Text>
          </Text>
        </Col>
      </Row>
    </div>
  );
}
